"use client";

import { useEffect, useRef } from "react";

import * as track from "../../tracking/wishlist.tracking";

export const Init = () => {
  const hasDispatchedRef = useRef(false);

  useEffect(() => {
    if (hasDispatchedRef.current) return;
    track.wishlistPageView();
    hasDispatchedRef.current = true;
  }, []);

  return null;
};
